import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes/mediaFullSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const voxboxInfoBlockSchema = Joi.object({
  type: Joi.string().valid('voxboxInfoBlock', 'voxboxInfo').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  subtitle: Joi.string().allow('', null),
  description: Joi.string().allow('', null).required(),
  textColor: Joi.string().allow('', null).required(),
  buttonText: Joi.string().allow('', null).required(),
  buttonUrl: Joi.string().allow('', null).required(),
  buttonTarget: Joi.string().allow('', null).required(),
  linkText: Joi.string().allow('', null),
  linkUrl: Joi.string().allow('', null),
  variant: Joi.string().allow('', null).required(),
  video: Joi.object({
    video: mediaFullSchema(true).allow(null).required(),
    thumbnail: mediaUrlSchema.allow(null).required()
  }) || mediaUrlSchema.allow(null).required(),
  image: mediaUrlSchema.allow(null).required(),
  ...blockAppearanceSchema
}).unknown(true);
export default voxboxInfoBlockSchema;